module.exports = __webpack_public_path__ + "static/media/logo__0001_PlainJoe.143a048e.png";